import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../http.service';
import { HelperService } from '../helper.service';
import { HttpClient } from '@angular/common/http';
import { FormControl } from '@angular/forms';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { KRollService } from './kroll.service';
import { CommonService } from './common.service';
@Injectable({
  providedIn: 'root'
})
export class ShippingService {
  controller: string = 'admin/shipping';
  selectedLocation = new FormControl(0);
  deliveryPartnerName: any
  tenant: any = localStorage.getItem('tenant')
  constructor(
    private httpService: HttpService,
    public helperService: HelperService,
    public httpClient: HttpClient,
    public toastr: ToastrService,
    public commonService: CommonService,
    public krollService: KRollService,
    private router: Router) {
  }
  get_delivery_partner() {
    return this.httpService.get(`${this.controller}/get_delivery_partner`);
  }

  get_sender_information(payload: any) {
    return this.httpService.post(`${this.controller}/get_sender_information`, payload).pipe(map((res: any) => {
      let response: any = res;
      if (response['body']['success']) {
        let senderInformation = response.body.data[0];
        if (senderInformation.PhoneNumber) {
          senderInformation.CountryCode = senderInformation.PhoneNumber.CountryCode;
          senderInformation.AreaCode = senderInformation.PhoneNumber.AreaCode;
          senderInformation.Phone = senderInformation.PhoneNumber.Phone;
          delete (senderInformation.PhoneNumber);
        }
        response.body.data = senderInformation;
      }
      return response;
    }));
  }
  // cancel_sales_order(payload: any) {

  //   if(this.tenant == 'pl'){
  //     return this.httpService.post(`admin/moneris/cancel_order`, payload);
  //   }else{
  //     return this.httpService.post(`admin/kroll/cancel_sales_order`, payload);
  //   }

  // }

  // TODO: Temporary implementation during payment method change
  cancel_sales_order(payload: any) {
    if (payload?.cardFrom == 'moneris' && (this.tenant == 'qc' || this.tenant == 'ml_qc')) {
      return this.httpService.post(`admin/moneris/cancel_order`, payload);
    }
    if (payload?.cardFrom == 'stripe') {
      return this.httpService.post(`admin/kroll/cancel_sales_order`, payload);
    }
    // Default fallback
    if (this.tenant == 'qc' || this.tenant == 'ml_qc') {
      return this.httpService.post(`admin/moneris/cancel_order`, payload);
    }
    return this.httpService.post(`admin/kroll/cancel_sales_order`, payload);
  }
  
  // cancel_processed_order(payload: any) {

  //   if(this.tenant == 'pl'){
  //     return this.httpService.post(`admin/moneris/cancel_processed_order`, payload);
  //   }else{
  //     return this.httpService.post(`admin/shipping/cancel_processed_order`, payload);
  //   }

  // }

// TODO: Temporary implementation during payment method change
cancel_processed_order(payload: any) {
  if (payload?.cardFrom == 'moneris' && (this.tenant == 'qc' || this.tenant == 'ml_qc')) {
        return this.httpService.post(`admin/moneris/cancel_processed_order`, payload);
      }
      if (payload?.cardFrom == 'stripe') {
        return this.httpService.post(`admin/shipping/cancel_processed_order`, payload);
      }
      // Default fallback
      if (this.tenant == 'qc' || this.tenant == 'ml_qc') {
        return this.httpService.post(`admin/moneris/cancel_processed_order`, payload);
      }
      return this.httpService.post(`admin/shipping/cancel_processed_order`, payload);
  }

  check_rate(payload: any) {
    return this.httpService.post(`${this.controller}/check_rate`, payload);
  }
  create_delivery_partner(payload: any) {
    return this.httpService.post(`${this.controller}/create_delivery_partner`, payload);
  }
  get_delivery_status() {
    return this.httpService.get(`${this.controller}/get_status_for_front_end`);
  }
  update_delivery_status(payload: any) {
    return this.httpService.post(`${this.controller}/update_status`, payload);
  }
  create_shipment_order(payload: any) {
    return this.httpService.post(`${this.controller}/create_shipment_order`, payload);
  }
  async setCheckRatePayload(senderInformation: any, selectedPaitents: any, selectedLocation: any): Promise<any> {
    let shipments: any[] = [];
    let PickupRequest:any
    for (let f of selectedPaitents) {
      let splitAddress1 = f.Address1 ? f.Address1.split(' ') : [];
      let splitStreetNumber = splitAddress1 ? splitAddress1.splice(0, 1) : [];
      let Address2 = f.Address2 == null ? '' : f.Address2;
      let phoneWithCode = f.kroll_pat_phone.length > 0 ? f.kroll_pat_phone[0].Phone : ''
      let areaCode = phoneWithCode ? phoneWithCode.split(')')[0].split('(')[1] : '';
      let postalCode = f.Postal ?? '';
      let Unit = f.Unit ? f.Unit : '';
      let BuzzerCode = f.BuzzerCode ? f.BuzzerCode : '';
      let StreetNumber = splitStreetNumber[0];
      let StreetName = `${splitAddress1.toString().replaceAll(',', ' ')}`;
      let City = f.City ?? '';
      let DeliveryPartner = f.DeliveryPartnerID;
      let Geolocation = "";
      if (f.Address1) {
        await this.commonService.getLocationDetail(`${f.Address1} Canada`).then((res: any) => {
          let val = res.address_components;
          let route = val.find((f: any) => f.types.find((t: any) => t === 'route'))?.long_name;
          let street_number = val.find((f: any) => f.types.find((t: any) => t === 'street_number'))?.long_name;
          postalCode = f.Postal ?? val.find((f: any) => f.types.find((t: any) => t === 'postal_code')).long_name;
          let Unit = f.Unit ? f.Unit : '';
          let BuzzerCode = f.BuzzerCode ? f.BuzzerCode : '';
          City = City ?? val.find((f: any) => f.types.find((t: any) => t === 'sublocality'))?.long_name;
          StreetNumber = StreetNumber ?? street_number ?? route ?? "";
          StreetName = StreetName ?? route;
          Geolocation = res.formatted_address;
        }, (err: any) => {
          postalCode = f.Postal ?? f.Address1;
          City = City ?? f.Address1;
          Unit = f.Unit ? f.Unit : '';
          BuzzerCode = f.BuzzerCode ? f.BuzzerCode : '';
          StreetNumber = StreetNumber ?? f.Address1;
          StreetName = StreetName ?? f.Address1;
          Geolocation = f.Address1;
        })
      }
      let receiverInfo = {
        Address1: f.Address1,
        Address2: Address2,
        Country: 'CA',
        City: City,
        Name: `${f.FirstName} ${f.LastName}`,
        PostalCode: postalCode,
        Unit: Unit,
        BuzzerCode: BuzzerCode,
        Province: f.Prov ?? '',
        CountryCode: "+1",
        AreaCode: areaCode,
        Phone: phoneWithCode ? phoneWithCode.includes(')') ? phoneWithCode.split(')')[1].replace(/-|\s/g, "") : phoneWithCode.replace(/-|\s/g, "") : "",
        StreetNumber: StreetNumber,
        StreetName: StreetName,
        StreetType: "",
        Company: "",
        Department: "",
        FirstName: f.FirstName ?? '',
        LastName: f.LastName ?? '',
        Email: f.EMail ?? '',
        Geolocation: `${f.Address1} ${f.City} ${f.Prov} ${f.Postal} ${f.Country}`,
        SignatureValue: f.SignatureValue,
        Delivery_instruction: f.Delivery_instruction ? f.Delivery_instruction : ""
      }
      // if(this.deliveryPartnerName == 'Canada Post'){
      //   PickupRequest= {
      //     PickupType: "OnDemand",
      //     PickupVolume: "1200",
      //     Date: "2023-08-18",
      //     PreferredTime: "12:00",
      //     ClosingTime: "17:00",
      //     Email: "shipping@pillway.com",
      //     Name: "Pillway Pharmacy",
      //     Phone: "123-456-7890"
      //   }
      // }
      shipments.push({
        DeliveryPartner: DeliveryPartner,
        OrderID: f.OrderID,
        UserID: f.UserID,
        SalesOrderID: f.ID,
        Amount: f.PaymentDue,
        DoNotShip: f.Address2 == "DO NOT SHIP" ? true : false,
        Shipment: {
          ...this.getShipmentByDeliveryPartner(DeliveryPartner, receiverInfo, f),
          Notes: f.Address2 == "DO NOT SHIP" ? "" : f.Address2,
          ServiceCode: f.ServiceCode ? f.ServiceCode : null,
          OptionCode: f.OptionCode ? f.OptionCode : null,
          TrackingReferenceInformation: {
            Reference1: 'Reference For Shipment'
          },
          ParcelCharacteristics: {
            "Weight": f?.Measurments?.Weight,
            "Length": f?.Measurments?.Length,
            "Width": f?.Measurments?.Width,
            "Height": f?.Measurments?.Height,
            "Unpackaged": false,
            "MailingTube": false
          }
        }
      })
    }
    return {
      Location: selectedLocation,
      SenderInformation: senderInformation,
      Shipments: shipments,
      // PickupRequest: PickupRequest
    };
  }
  getShipmentByDeliveryPartner(DeliveryPartner: string | number, receiverInfo: any, item: any) {

    let { Measurments } = item;
    if (DeliveryPartner == 1) {
      let packagingInfo = {
        TotalWeightValue: Measurments.Weight,
        TotalWeightUnit: "lb",
        TotalPieces: "1",
        ServiceID: "PurolatorExpress",
        PiecesInformation: [{
          WeightValue: Measurments.Weight,
          WeightUnit: "lb",
          LengthValue: Measurments.Length,
          LengthDimensionUnit: "in",
          WidthValue: Measurments.Width,
          WidthDimensionUnit: "in",
          HeightValue: Measurments.Height,
          HeightDimensionUnit: "in",
          OptionIDValuePair: [
            {
              ID: "SpecialHandling",
              Value: "false"
            },
            {
              ID: "SpecialHandlingType",
              Value: ""
            }]
        }],
        OptionsInformation: item.SignatureRequired ? [{
          ID: "OriginSignatureNotRequired",
          // Value: !item.SignatureRequired
          Value: "false"
        },
        {
          ID: "ResidentialSignatureDomestic",
          Value: "true"
        }
        ] : [{
          ID: "OriginSignatureNotRequired",
          // Value: !item.SignatureRequired
          Value: "true"
        },
        {
          ID: "ResidentialSignatureDomestic",
          Value: "false"
        }
        ]
      }
      return {
        ShipmentDate: this.helperService.convertToDashDate(new Date()),
        ShowAlternativeServicesIndicator: "true",
        ReceiverInformation: receiverInfo,
        PaymentInformationPaymentType: 'Sender',
        PickupInformationPickupType: 'DropOff',
        PackageInformation: packagingInfo
      }
    }
    else if (DeliveryPartner == 2) {
      let packagingInfo = {
        "PackageInformation": {
          "WoType": "SMP",
          "NoPackages": 1,
          "NoOverWeightPackages": 0,
          "NoLtlSkids": 1,
          "TotalWeight": Measurments.Weight,
          "TotalDimWeight": Measurments.Weight
        },
        "ServiceType": "102",
        "GenerateShippingLabel": true,
        // "SignatureRequired": item.SignatureRequired,
        "SignatureRequired": true,
        "ServiceDate": this.helperService.convertToDashDate(new Date()),

        "PoNumber": item.OrderID,
        "AppointmentRequired": "0",
        // "AppointmentNotes": "0",
        "AppointmentNotes": item.Address2 == "DO NOT SHIP" ? "" : item.Address2,

        "ShipFromAddressId": 1,
        "ReferenceNumber": item.OrderID,
        "DeclaredValue": "2.0",
        "TrackingNumber": "123",
        "FromTrackingDate": "2021-07-06 00:00:00",
        "OrderDate": "2021-07-06",
        "LocationId": "37"
      }
      return {
        ReceiverInformation: receiverInfo,
        ...packagingInfo
      }
    }
    else if (DeliveryPartner == 3) {
      let receiverInfoObj = receiverInfo;
      receiverInfoObj.StreetType = 'Street';
      return {
        ShipmentDate: this.helperService.convertToDashDate(new Date()),
        ReceiverInformation: receiverInfoObj,
      }
    }
    else {
      let packagingInfo = {
        "PackageInformation": {
          "ServiceID": "LocalDeliveryPartner",
          "TotalPieces": "1",
          "TotalWeightUnit": "lb",
          "TotalWeightValue": "1"
        },
        "ServiceDate": this.helperService.convertToDashDate(new Date()),
        "ShowAlternativeServicesIndicator": "true",
        "PaymentInformationPaymentType": "Sender",
        "PickupInformationPickupType": "DropOff",
        "PrinterType": "Thermal",
      }
      return {
        ReceiverInformation: receiverInfo,
        ...packagingInfo
      }
    }
  }
  custom_message(payload: any) {
    return this.httpService.post(`${this.controller}/custom_message`, payload);
  }
  invoice(payload: any) {
    return this.httpService.post(`admin/sales/invoice`, payload).pipe(map((res: any) => {
      let response: any = res;
      if (response['body']['success']) {
        let data: any = response['body']['data'][0];
        let TypeCode = data.TaxCode.map((m: any) => m.TypeCode);
        let KrollRxPlnFlat = data.Drugs.flatMap((fm: any) => fm.kroll_rx_pln);
        let KrollRxPlnFlatDistinct = KrollRxPlnFlat.filter((f: any, i: number, arr: any) => arr.findIndex((m: any) => m.SubPlanCode === f.SubPlanCode) === i).map((m: any) => m.SubPlanCode);

        data.Date = this.helperService.convertToDashDate(data.DateTime);
        data.Time = this.helperService.getTime(data.DateTime);
        data.PhoneNumber = data.Phone.map((m: any) => `+1${m.Phone}`).join(', ');
        data.CompleteAddress = `${data.Address1 ?? ''} ${data.City} ${data.Prov} ${data.Postal ?? ''} ${data.Country} ${data.Address2 == "DO NOT SHIP" ? "" : data.Address2 ?? ''}`;
        data.Drugs = data.Drugs.map((m: any) => {
          return {
            ...m,
            TypeCode: m.IsPrescripitonMedication ? 'N' : TypeCode.toString(),
            TypeCodeArr: m.IsPrescripitonMedication ? [] : TypeCode,
            Coverage: m.kroll_rx_pln.filter((f: any) => !f.SubPlanCode.toLowerCase().match("cash")).reduce((acc: any, val: any) => acc + (+val.Pays), 0),
            YouPay: m.kroll_rx_pln.filter((f: any) => f.SubPlanCode.toLowerCase().match("cash")).reduce((acc: any, val: any) => acc + (+val.Pays), 0),
          }
        });
        data.SubTotalCoverage = data.Drugs.reduce((acc: any, val: any) => acc + (+val.Coverage), 0).toLocaleString();
        data.SubTotalYouPay = data.Drugs.reduce((acc: any, val: any) => acc + (+val.YouPay), 0).toLocaleString();
        // TotalTax
        data.TaxCode = data.TaxCode.map((m: any) => {
          return {
            ...m,
            "TotalTax": data.Drugs.reduce((acc: number, val: any) => {
              if (val.TypeCodeArr.includes(m.TypeCode)) {
                acc = acc + Math.round(((+val.YouPay) / m.Tax) * 100);
              }
              return acc;
            }, 0) ?? 0
          }
        })
        data.TotalYouPay = +data.SubTotalYouPay + data.TaxCode.reduce((acc: number, val: any) => acc + (+val.TotalTax), 0);
        // TotalRxPlan
        data.TotalRxPlan = KrollRxPlnFlatDistinct.reduce((acc: any[], val: any) => {
          let SubPlanCodeArr = KrollRxPlnFlat.filter((f: any) => f.SubPlanCode == val);
          if (SubPlanCodeArr.length > 0) {
            let payload = {
              key: val,
              value: SubPlanCodeArr.reduce((acc: any, val: any) => acc + (+val.Pays), 0).toLocaleString()
            }
            acc.push(payload);
          }
          return acc;
        }, []);
        response['body']['data'] = data;
        return response;
      }
      return response;
    }));
  }

  createLowActivityReason(payload: any) {
    return this.httpService.post('admin/reason/add', payload);
  }

  // For Wylo

  verify_rx_before_create(obj: any) {
    return this.httpService.post(`admin/wylo/order/verify-rx-before-create`, obj);
  }

  save_rx_for_draft(obj: any) {
    return this.httpService.post(`admin/wylo/order/save-rx-for-draft`, obj);
  }

  convert_draft_into_sales(obj: any) {
    return this.httpService.post(`admin/wylo/order/convert-draft-into-sales`, obj);
  }

  delete_draft_order(obj: any) {
    return this.httpService.post(`admin/wylo/kroll/delete_draft_order`, obj);
  }

  // Wylo End

  update_order_shpping_address(obj: any) {
    return this.httpService.post(`admin/kroll/update_order_shpping_address`, obj);
  }

  refresh_Kroll_Addr(obj: any) {
    return this.httpService.post(`admin/kroll/refresh_kroll_address_of_order`, obj);
  }
  
  check_order_addr_match(obj: any) {
    return this.httpService.post(`admin/kroll/check_order_shipping_address_mismatch`, obj);
  }
  
  batch_renew_refill(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/index`, obj);
  } 
  
  refill_get_drug_list(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/get_drug_list`, obj);
  }

  sales_order_detail(obj: any) {
    return this.httpService.post(`admin/sales_order_detail`, obj);
  }

  sales_order_replace_rx(obj: any) {
    return this.httpService.post(`admin/replace_rx`, obj);
  }

  sales_order_add_rx(obj: any) {
    return this.httpService.post(`admin/add_rx`, obj);
  }

  sales_order_remove_rx(obj: any) {
    return this.httpService.post(`admin/remove_rx`, obj);
  }

  verify_rx_request_order(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/verify_rx_request_order`, obj);
  } 
  
  renew_refill_process_order(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/proceed_sales_order`, obj);
  }

  req_order_status_list(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/order_status_list`, obj);
  }
  
  update_req_status(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/update_order_status_list`, obj);
  }

  get_field_rx_list(obj: any) {
    return this.httpService.post(`admin/user/get_field_rx_list`, obj);
  }  
  rxnullAssignReason(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/reason_list`, obj);
  }
  
  assign_reason(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/assign_reason`, obj);
  }

  clear_rx_num_id(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/clear_rx`, obj);
  }

  move_patient_review(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/move_patient_review`, obj);
  }
  
  refill_cancel_request_order(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/update_order_status_list`, obj);
  }

  medWaiting_for_prescriber(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/assign_waiting_for_prescriber`, obj);
  } 
  
  allWaiting_for_prescriber(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/mark_waiting_for_prescriber`, obj);
  }

  add_med_rx_num(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/create-request-by-rx`, obj);
  }  
  
  add_manual_ord_rx(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/add_rx_for_manual_request_order`, obj);
  }
  
  add_rx_request_order(obj: any) {
    return this.httpService.post(`admin/user/batch_renew_refill/add_rx_request_order`, obj);
  }  

}
